export default "__VITE_ASSET__DToHX2mN__"